
import store from '@/store/store';
export default {

	computed: {

	},
	mounted: function () {
		if (this.$options.name) {
			if (!this.nonPageList.contains(this.$options.name)) {
				//页面初始化  监听modal的关闭，
				$('.modal').on('hide.bs.modal', function () {
					var form = $(this).find('form');
					if (form.length > 0) {
						form.each(function () {
							$(this).get(0).reset();
							if ($(this).find('small').length > 0 && $(this).data('bootstrapValidator')) {
								if ($(this).attr('data-close') == 'destroy') {
									$(this).data('bootstrapValidator').destroy();
								} else {
									$(this).data('bootstrapValidator').resetForm(true);
								}

							}
						})
					}
				});

				//绑定日期事件
				let that = this;
				$('input[data-daterange]:not([init])', this.$el).each(function (i, o) {
					$(this).attr('init', true)
					let props = $(this).attr('data-daterange').split(',');
					let config = that.config.daterange;

					if (that.form[props[0]] != '' && that.form[props[1]] != '') {
						config.startDate = that.form[props[0]];
						config.endDate = that.form[props[1]];
					} else {
						config.autoUpdateInput = false;
					}
					$(this).daterangepicker(config,
							function (start, end, label) {
								that.form[props[0]] = start.format('MM/DD/YYYY');
								that.form[props[1]] = end.format('MM/DD/YYYY');
							}).on('cancel.daterangepicker', function (ev, picker) {
						$(this).val('');
						that.form[props[0]] = '';
						that.form[props[1]] = '';
					}).on('apply.daterangepicker', function (ev, picker) {
						$(this).val(picker.startDate.format('MM/DD/YYYY') + ' ~ ' + picker.endDate.format('MM/DD/YYYY'));
						that.form[props[0]] = picker.startDate.format('MM/DD/YYYY');
						that.form[props[1]] = picker.endDate.format('MM/DD/YYYY');
					})
				})

			}
		}
		//console.log(this.$options.name);
	},
	methods: {
		getPage() {
			if (this.$route.query.page) {
				return parseInt(this.$route.query.page);
			} else {
				return 1;
			}
		},
		getURL() {
			return window.location.href.replace(/[?&]page=\d+/, '');
		},
		/*
		 getQuery(form){
		 var query = {};
		 for(var key in form){
		 if(form[key] != ''){
		 query[key] = form[key];
		 }
		 }
		 return {};
		 },
		 */
		formatDate: function (time, format) {
			return moment(time).tz(timezone).format(format || 'MM/DD/YYYY HH:mm:ss');
		},
		hasColumn: function (field, key) {
			if (!key) {
				key = store.state.path;
			}
			if (store.state.column_map[key]) {
				return store.state.column_map[key].contains(field);
			} else {
				return true;
			}
		},
		getParameter: function (name) {
			return this.$route.query[name] || '';
		},
		param: function (name) {
			return this.getParameter(name);
		}
		,
		saveForm(event) {
			$(event.target).parents('.modal').eq(0).find('form').bootstrapValidator('validate');
		},
		hasPermission: function (path) {
			return store.state.permissions.contains(path);
		},
		formatTime: function (time) {
			if (time <= 0) {
				return '';
			}
			var h = 0, m = 0, s = 0;
			var _t = Math.floor(time / 60 / 60);
			if (_t > 0) {
				h = Math.floor(_t);
				time = time - (h * 60 * 60);
			}
			_t = Math.floor(time / 60);
			if (_t > 0) {
				m = Math.floor(_t);
				time = time - (m * 60);
			}
			s = Math.floor(time);
			return (h > 0 ? (h + " '' ") : "") + (m > 0 ? (m + " '' ") : "") + (s > 0 ? (s + " ") : "");
		},
		/* 处理localDateTime 格式的时间  */
		formatTimeLocal(time){
			if(!time){
				return ''
			}
			let {
				dayOfMonth, hour, minute, monthValue, second, year,
			} = time
			let dataTime = `${year}-${monthValue}-${dayOfMonth} ${hour}:${minute}:${second}`
			return moment(dataTime).format('MM/DD/YYYY HH:mm:ss')
		},
		search: function () {
			this.form.click = new Date().getTime().toString(36);
			this.$router.push({query: this.form});
		},
		previewImage(e) {
			layer.photos({
				photos: {data: [{src: $(e.target).attr('src')}]}
				, anim: 5 //0-6的选择，指定弹出图片动画类型，默认随机（请注意，3.0之前的版本用shift参数）
			})
		}
		, copy: function (event) {
			var em = event.currentTarget;
			var sel = window.getSelection();
			sel.removeAllRanges();
			em.select && em.select();
			var range = document.createRange();
			range.selectNodeContents(em);
			sel.addRange(range);
			em.setSelectionRange && em.setSelectionRange(0, 999999);
			if (document.execCommand('copy')) {
				common.tip('Copy Success');
			} else {
				common.tip('Copy Failure');
			}
//			sel.removeAllRanges();
		}
	},
	data() {
		return {
			//title:'安徽石油MPS系统'
			nonPageList: ['Home', 'ColumnChooser', 'PageBar'],
			config: {
				format: {
					datetime: 'MM/DD/YYYY HH:mm',
					datetime_full: 'MM/DD/YYYY HH:mm:ss',
					date: 'MM/DD/YYYY'
				},
				daterange: {

					ranges: {
						'Today': [moment(), moment()],
						'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
						'Last 7 Days': [moment().subtract(6, 'days'), moment()],
						'Last 30 Days': [moment().subtract(29, 'days'), moment()],
						'This Month': [moment().startOf('month'), moment().endOf('month')],
						'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
					},
					locale: {
						"separator": " ~ ",
						"cancelLabel": "Clear"
					}
				}
			}
		}
	},
	updated: function () {
		if (this.$options.name) {
			if (!this.nonPageList.contains(this.$options.name) && this.updateQueue) {
				while (this.updateQueue.length) {
					this.updateQueue.shift().bind(this)()
				}
			}
		}

	}
	/*
	 ,
	 beforeDestroy:function(){
	 console.log(this.$options.name)
	 }
	 */
}



// WEBPACK FOOTER //
// ./src/views/main/mixins/index.js